import { render, staticRenderFns } from "./lockScreen.vue?vue&type=template&id=422ac38d&"
import script from "./lockScreen.vue?vue&type=script&lang=js&"
export * from "./lockScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports